module.exports = __webpack_public_path__ + "img/GajaUtsavOdishalogo.32ae9694.png";